import { useEffect } from 'react';
import { rtLogService } from '@rammetec/core';
import { useSystemApiWsClient } from '../context/SystemApiWsContext.js';
import { useAuthService } from '../context/AuthServiceContext.js';
import { useSync } from './useSync.js';
/**
 * Listens for remote commands via the System API WebSocket control channel.
 * No-op when the WS client is not connected (VH live data comes from the VH
 * server directly — Phase 8). Mount once at the app root.
 *
 * Supported: `logout`, `sync`.
 */
export function useRemoteCommands() {
    const wsClient = useSystemApiWsClient();
    const authService = useAuthService();
    const { sync } = useSync();
    useEffect(() => {
        if (!wsClient)
            return;
        const unsub = wsClient.onControl('remoteCommand', (payload) => {
            const command = payload?.command;
            if (!command)
                return;
            switch (command) {
                case 'logout':
                    wsClient.close();
                    void authService.logout().catch((err) => rtLogService.warn('[useRemoteCommands] Remote logout failed', { err }));
                    break;
                case 'sync':
                    void sync();
                    break;
                default:
                    rtLogService.warn('[useRemoteCommands] Unknown command', { command });
            }
        });
        return unsub;
    }, [wsClient, authService, sync]);
}
//# sourceMappingURL=useRemoteCommands.js.map